import Stat from "models/Stat";

export default class LocalStorageService {

    loadDefaultStats(): Array<Stat> {
        const rawStats = window.localStorage.getItem('defaultStats');
        return rawStats ? JSON.parse(rawStats).map(rawStat => new Stat(rawStat)) : [];
    }

    saveDefaultStats(stats: Array<Stat> = []): void {
        window.localStorage.setItem('defaultStats', JSON.stringify(stats));
    }
}